<template lang='pug' src='./custom-sponsor-welcome.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['content'],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// custom-sponsor-welcome.vue?89a2c4bc